import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/models/user.model';
import { AccountService } from 'src/app/services/account.service';
import { CallHubService } from '../../services/call-hub.service';
@Component({
  selector: 'app-login-page',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})

export class LoginPage implements OnInit {
  user: any = {
    username: '',
    password: ''
  };
  err: string;

  constructor(public accountService: AccountService, private router: Router, private translate: TranslateService,
     private callHub: CallHubService
  ) {}

  ngOnInit(): void {}

  login(){
    this.accountService.login(this.user).subscribe(user => {   
      this.router.navigateByUrl(this.accountService.homepageRoutes[user.role]);
       const userStorage = JSON.parse(localStorage.getItem('loggedUser') || 'null') as User | null;
          this.accountService.setCurrentUser(user || undefined);
      
         const ext = user?.operaterId ? String(user.operaterId).trim() : null;
          if (ext) {
            this.callHub.connect(ext);
            console.log('[CALL] connected for ext:', ext);
          } else {
            console.warn('[CALL] Nema operaterId na korisniku – ne povezujem SignalR.');
          }
    },error =>{
      this.err = this.translate.instant('LOGIN.bad_login');
      console.log(error);
    });
  }
}
